import { render, staticRenderFns } from "./CornerLeftTop.vue?vue&type=template&id=8d264ef2&scoped=true&"
import script from "./CornerLeftTop.vue?vue&type=script&lang=js&"
export * from "./CornerLeftTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d264ef2",
  null
  
)

export default component.exports